import { checkForEmptyParams } from "../lib";
import dayjs from "dayjs";

const ROOT_API = process.env.REACT_APP_API_ENDPOINT;

export const getFilterConfig = () =>
  fetch(`${ROOT_API}/config`).then((res) => res.json());

export const getNumberOfMarkets = ({
  basedOn,
  markets,
  competitions,
  fixtureId,
  fixtures,
  date,
  minOdds,
  maxOdds,
}) => {
  // remove empty values from params
  const params = {
    basedOn,
    markets,
    competitions,
    fixtureId,
    fixtures,
    date,
    tzOffset: String(dayjs().utcOffset()),
    minOdds,
    maxOdds,
  };

  const searchParams = new URLSearchParams(checkForEmptyParams(params));

  return fetch(`${ROOT_API}/selections/count?${searchParams}`).then((res) =>
    res.json()
  );
};

export const getFixtures = () =>
  fetch(`${ROOT_API}/fixtures?tzOffset=${dayjs().utcOffset()}`).then((res) =>
    res.json()
  );

export const getSelections = ({
  basedOn,
  markets,
  competitions,
  fixtureId,
  fixtures,
  date,
  order,
  limit,
  offset,
  minOdds,
  maxOdds,
}) => {
  // remove empty values from params
  const params = {
    basedOn,
    markets,
    competitions,
    fixtureId,
    fixtures,
    date,
    order,
    limit,
    offset,
    tzOffset: String(dayjs().utcOffset()),
    minOdds,
    maxOdds,
  };

  const searchParams = new URLSearchParams(checkForEmptyParams(params));

  return fetch(`${ROOT_API}/selections?${searchParams}`).then((res) =>
    res.json()
  );
};

export const shuffleSelections = (
  count,
  { date, fixtures, markets, minOdds, maxOdds }
) => {
  const params = {
    date,
    fixtures,
    markets,
    minOdds,
    maxOdds,
  };

  const searchParams = new URLSearchParams(checkForEmptyParams(params));

  const url = count
    ? `${ROOT_API}/shuffle?${searchParams}&count=${count}`
    : `${ROOT_API}/shuffle?${searchParams}`;

  return fetch(url).then((res) => res.json());
};
